import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ReceiptIcon from '@material-ui/icons/Receipt';
import {
  Card,
  CardActions,
  CardHeader,
  Divider,
  CardContent,
  Button,
  Grid,
  TextField,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Box,
  IconButton,
  TableFooter,
  DialogTitle,
  Dialog,
  DialogActions,
  DialogContent,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tooltip,
  Toolbar
} from '@material-ui/core';
import { Fab } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import Page from 'src/components/Page';
import { visuallyHidden } from '@mui/utils';
import { Link as RouterLink } from 'react-router-dom';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { useHistory } from 'react-router';
import { useTheme } from '@mui/material/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/CloseOutlined';
import SendIcon from '@material-ui/icons/Send';
import CircularProgress from '@mui/material/CircularProgress';
import CreateProjectDialog from '../../components/HavcComponents/CreateProjectDialog';
import UpdateProjectDialog from '../../components/HavcComponents/UpdateProjectDialog';
import Receipts from '../../components/HavcComponents/Receipts';
import DeleteProjectDialog from '../../components/HavcComponents/DeleteProjectDialog';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import EditIcon from '@material-ui/icons/Edit';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import HavcLogs from '../../components/HavcComponents/HavcLogs';
import CommentIcon from '@mui/icons-material/Comment';
import CommentPopup from '../../components/HavcComponents/Comments';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#f8fafc',
    minHeight: '100vh'
  },
  pageHeader: {
    marginBottom: theme.spacing(3)
  },
  mainCard: {
    borderRadius: '12px',
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    backgroundColor: '#ffffff',
    overflow: 'hidden'
  },
  cardHeader: {
    padding: theme.spacing(3),
    backgroundColor: '#ffffff',
    '& .MuiCardHeader-title': {
      fontSize: '1.5rem',
      fontWeight: 600,
      color: '#1e293b'
    }
  },
  searchSection: {
    padding: theme.spacing(3),
    backgroundColor: '#f8fafc'
  },
  tableContainer: {
    '& .MuiTableCell-head': {
      backgroundColor: '#f1f5f9',
      color: '#475569',
      fontWeight: 600,
      fontSize: '0.875rem',
      borderBottom: '2px solid #e2e8f0',
      padding: theme.spacing(2)
    },
    '& .MuiTableCell-body': {
      padding: theme.spacing(2),
      fontSize: '0.875rem',
      color: '#334155',
      borderBottom: '1px solid #f1f5f9'
    },
    '& .MuiTableRow-root:hover': {
      backgroundColor: '#f8fafc',
      transition: 'background-color 0.2s ease'
    }
  },
  actionButton: {
    minWidth: '120px',
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 500,
    padding: theme.spacing(1, 2),
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
    }
  },
  searchInput: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
      backgroundColor: '#ffffff',
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main
      }
    }
  },
  fabButton: {
    margin: theme.spacing(0.5),
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1)',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
    },
    transition: 'all 0.2s ease'
  },
  emptyState: {
    padding: theme.spacing(8, 2),
    textAlign: 'center',
    color: '#94a3b8'
  },
  loadingOverlay: {
    position: 'relative'
  },
  completionBadge: {
    padding: theme.spacing(0.5, 1.5),
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: 600,
    display: 'inline-block'
  }
}));

// table sort
function descendingComparator(a, b, orderBy) {
  const aValue =
    orderBy === 'CreateDate'
      ? new Date(
        a[orderBy]
          .split('.')
          .reverse()
          .join('-')
      )
      : a[orderBy];
  const bValue =
    orderBy === 'CreateDate'
      ? new Date(
        b[orderBy]
          .split('.')
          .reverse()
          .join('-')
      )
      : b[orderBy];

  if (bValue < aValue) return -1;
  if (bValue > aValue) return 1;
  return 0;
}

const getComparator = (order, orderBy) =>
  order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);

function stableSort(array, comparator) {
  //debugger;
  const stabilizedThis = Array.isArray(array)? array.map((el, index) => [el, index]) : [];
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

// table header options
const headCells = [
  {
    id: 'ProjectCode',
    numeric: false,
    label: 'ProjeKodu',
    align: 'left'
  },
  {
    id: 'ProjectOwner',
    numeric: false,
    label: 'ProjeAdı',
    align: 'left'
  },
  {
    id: 'Description',
    numeric: false,
    label: 'Proje',
    align: 'left'
  },
  {
    id: 'ProjectType',
    numeric: false,
    label: 'ProjeTipi',
    align: 'left'
  },
  {
    id: 'ServiceShop',
    numeric: true,
    label: 'Servis',
    align: 'left'
  },
  {
    id: 'MentorServiceShop',
    numeric: true,
    label: 'MentorServis',
    align: 'left'
  },
  {
    id: 'Dealer',
    numeric: true,
    label: 'Satıcı',
    align: 'left'
  },
  {
    id: 'Region',
    numeric: false,
    label: 'Bölge',
    align: 'left'
  },
  {
    id: 'City',
    numeric: false,
    label: 'İl',
    align: 'left'
  },
  {
    id: 'Completion',
    numeric: false,
    label: 'TamamlanmaOranı',
    align: 'left'
  },
  {
    id: 'CreateDate',
    numeric: false,
    label: 'OluşturulmaTarihi',
    align: 'left'
  },
  {
    id: 'Actions',
    numeric: false,
    label: 'İşlemler',
    align: 'center'
  }
];

function EnhancedTableHead({
  onSelectAllClick,
  order,
  orderBy,
  numSelected,
  rowCount,
  onRequestSort,
  theme,
  selected
}) {
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {numSelected > 0 && (
          <TableCell padding="none" colSpan={7}>
            <EnhancedTableToolbar numSelected={selected.length} />
          </TableCell>
        )}
        {numSelected <= 0 &&
          headCells.map(headCell => (
            <TableCell
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablepadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{
                backgroundColor: '#f1f5f9',
                color: '#475569',
                fontWeight: 600,
                borderBottom: '2px solid #e2e8f0'
              }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
                sx={{
                  '&.Mui-active': {
                    color: '#0f172a',
                    fontWeight: 700
                  },
                  '&:hover': {
                    color: '#1e293b'
                  }
                }}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc'
                      ? 'sorted descending'
                      : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  theme: PropTypes.object,
  selected: PropTypes.array,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired
};

// ==============================|| TABLE HEADER TOOLBAR ||============================== //

const EnhancedTableToolbar = ({ numSelected }) => (
  <Toolbar
    sx={{
      p: 0,
      pl: 1,
      pr: 1,
      ...(numSelected > 0 && {
        color: theme => theme.palette.secondary.main
      })
    }}
  >
    {numSelected > 0 ? (
      <Typography color="inherit" variant="h4">
        {numSelected} Selected
      </Typography>
    ) : (
      <Typography variant="h6" id="tableTitle">
        Nutrition
      </Typography>
    )}
    <Box sx={{ flexGrow: 1 }} />
    {numSelected > 0 && (
      <Tooltip title="Delete">
        <IconButton size="large">
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    )}
  </Toolbar>
);

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired
};

const initialFormState = {
  projectId: 0,
  projectOwner: '',
  service: '',
  mentorService: '',
  dealer: '',
  region: '',
  city: '',
  brand: '',
  totalOdu: 0,
  totalIdu: 0,
  controlRoomCount: 0,
  systemCount: 0,
  registrationDate: '01.01.2023',
  responsibleTechnician: '',
  serviceManager: '',
  description: '',
  dealerManager: '',
  creator: '',
  modifier: ''
};

function HVAC() {
  const classes = useStyles();
  const history = useHistory();
  const [roleTypes, setRoleTypes] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedArea, setselectedArea] = React.useState([]);
  const [selectedAreaData, setselectedAreaData] = React.useState([]);
  const [selectedServiceShop, setselectedServiceShop] = React.useState([]);
  const [selectedServiceShopData, setselectedServiceShopData] = React.useState(
    []
  );
  const [selected, setSelected] = React.useState([]);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [HvacData, setHvacData] = React.useState([]);
  const [HvacDataMain, setHvacDataMain] = React.useState([]);
  const [OpenCreateDialog, setOpenCreateDialog] = React.useState(false);
  const [OpenUpdateDialog, setOpenUpdateDialog] = React.useState(false);
  const [OpenReceiptsDialog, setOpenReceiptsDialog] = React.useState(false);
  const [OpenDeleteProjectDialog, setOpenDeleteProjectDialog] = React.useState(
    false
  );
  const [formData, setFormData] = useState(initialFormState);
  const [selectedRow, setSelectedRow] = React.useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const SessionUser = getUser();
  const theme = useTheme();
  const [search, setSearch] = useState('');
  const [HavcAddressData, setHavcAddressData] = React.useState([]);
  const [permissions, setPermissions] = useState([]);
  const [exceptionalUsers, setExceptionalUsers] = useState([]);
  const [fislerYeniEkranAc, setFislerYeniEkranAc] = useState(false);
  const [OpenLogsDialog, setOpenLogsDialog] = React.useState(false);
  const [openCommentDialog, setOpenCommentDialog] = React.useState(false);
  console.clear();

  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(false);
  };

  const handleUpdateSuccess = (projectId) => {
    sorgula(projectId);
    setSearch(projectId);
  }

  useEffect(() => {
    try {
      const mainArray = JSON.parse(
        localStorage.getItem('HavcComboData').replace(/\\"/g, '"')
      );
      setselectedAreaData(mainArray[0].BOLGE);
      setselectedServiceShopData(mainArray[0].SERVIS);
      setPermissions(mainArray[0].ROLES);
      setExceptionalUsers(mainArray[0]?.EXUSERS);

      axios
        .get('/GetHavcComboAddressValues')
        .then(response => {
          setHavcAddressData(response.data.length === 0 ? [] : response.data);
        })
        .catch(error => { });
    } catch {
      console.log('Bir hata oluştu.');
    }
  }, []);

  const sorgula = (customSearch) => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem('user'));
    const bolge = selectedArea?.Id ? selectedArea?.Id : 0;
    const servis = selectedServiceShop?.Id ? selectedServiceShop?.Id : 0;
    const userId = user?.UserId.toString();
    const roleId = user?.Role_Id;
    let query;

    if (
      customSearch &&
      typeof customSearch === 'object' &&
      'target' in customSearch &&
      'value' in customSearch.target
    ) {
      query = customSearch.target.value;
    } else if (typeof customSearch === 'string') {
      query = customSearch;
    } else {
      query = search;
    }

    axios
      .get(`GetHavcProjects/${bolge}/${servis}/${roleId}/${userId}/${query}`)
      .then(response => {
        setHvacData(response.data);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
      });;
  };

  // useEffect(() => {
  //   sorgula();
  // }, []);



  const checkRolesAuth = field => {
    const user = JSON.parse(localStorage.getItem('user'));
    let roleId = user?.Role_Id;
    const userId = user?.UserId.toString();

    if (exceptionalUsers.filter(x => x.Id === userId).length > 0) {
      roleId = 15;
    }

    const roleCheck =
      permissions.filter(
        x =>
          x.HavcPage === 'HVAC/index' &&
          x.ApolloRoleId === roleId &&
          x.HavcField === field
      ).length > 0
        ? true
        : false;
    return roleCheck;
  };

  const handleLogsClick = () => {
    setOpenLogsDialog(true);
  };
  const handleCommentClick = () => {
    setOpenCommentDialog(true);
  };
  const handleEditClick = () => {
    setOpenUpdateDialog(true);
  };
  const handleDeleteClick = () => {
    setOpenDeleteProjectDialog(true);
  };
  const handleReceiptClick = type => {
    setOpenReceiptsDialog(true);
    if (type) {
      setFislerYeniEkranAc(true);
    } else {
      setFislerYeniEkranAc(false);
    }
  };

  const handleSearch = event => {
    setSearch(event.target.value);
  };

  const handleInputChange = e => {
    const { name, value } = e.target;
    setFormData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      if (selected.length > 0) {
        setSelected([]);
      } else {
        const newSelectedId = HvacData.map(n => n.name);
        setSelected(newSelectedId);
      }
      return;
    }
    setSelected([]);
  };

  const handleClickTable = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event?.target.value, 10));
    setPage(0);
  };

  const isSelected = name => selected.indexOf(name) !== -1;

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - 10) : 0;
  const SelectOptions = ['Option1', 'Option2', 'Option3'];

  return (
    <Page className={classes.root} title={'Enerji Çözümleri'}>
      <Box className={classes.pageHeader}>
        <Typography variant="h4" sx={{ color: '#0f172a', fontWeight: 700, mb: 1 }}>
          HVAC ve Enerji Çözümleri
        </Typography>
        <Typography variant="body2" sx={{ color: '#64748b' }}>
          Proje yönetimi ve takip sistemi
        </Typography>
      </Box>
      
      <Card className={classes.mainCard}>
        <Box className={classes.searchSection}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3} lg={3}>
              <Autocomplete
                size="small"
                id="combo-box-demo"
                fullWidth
                disabled={!checkRolesAuth('regionAutocomplete')}
                value={selectedArea}
                options={selectedAreaData}
                getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                onChange={(event, newValue) => {
                  setselectedArea(newValue);
                }}
                renderInput={params => (
                  <TextField 
                    {...params} 
                    label="Bölge" 
                    variant="outlined"
                    placeholder="Bölge seçiniz"
                    className={classes.searchInput}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <Autocomplete
                size="small"
                id="combo-box-demo"
                disabled={!checkRolesAuth('serviceAutocomplete')}
                fullWidth
                value={selectedServiceShop}
                options={selectedServiceShopData}
                getOptionLabel={option => (option.Dsc ? option.Dsc : '')}
                onChange={(event, newValue) => {
                  setselectedServiceShop(newValue);
                }}
                renderInput={params => (
                  <TextField 
                    {...params} 
                    label="Servis" 
                    variant="outlined"
                    placeholder="Servis seçiniz"
                    className={classes.searchInput}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={4} lg={4}>
              <TextField
                fullWidth
                id="input-search-card-style1"
                label="Arama"
                placeholder="Proje kodu, isim veya açıklama ile arayın..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onBlur={handleSearch}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    sorgula();
                  }
                }}
                autoComplete="off"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: '#94a3b8' }} />
                    </InputAdornment>
                  ),
                  endAdornment: search && (
                    <InputAdornment position="end">
                      <IconButton size="small" onClick={() => setSearch('')}>
                        <CloseIcon sx={{ fontSize: '1rem' }} />
                      </IconButton>
                    </InputAdornment>
                  )
                }}
                variant="outlined"
                size="small"
                className={classes.searchInput}
              />
            </Grid>
            <Grid item xs={12} sm={1} lg={1}>
              <Box sx={{ alignItems: 'center' }}>
                <Box sx={{ position: 'relative' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    fullWidth
                    onClick={sorgula}
                    disabled={loading}
                    startIcon={!loading && <SearchIcon />}
                    sx={{
                      minWidth: '120px',
                      borderRadius: '8px 0 0 8px',
                      textTransform: 'none',
                      fontWeight: 500,
                      padding: theme.spacing(1, 2),
                      boxShadow: 'none',
                      color: '#ffffff !important',
                      '&:hover': {
                        boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                        color: '#ffffff !important'
                      },
                      '&.Mui-disabled': {
                        color: 'rgba(255, 255, 255, 0.7) !important'
                      }
                    }}
                  >
                    {loading ? 'Yükleniyor...' : 'Sorgula'}
                  </Button>
                  {loading && (
                    <CircularProgress
                      size={20}
                      sx={{
                        color: '#ffffff',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-10px',
                        marginLeft: '-10px'
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={1} lg={1}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={() => setOpenCreateDialog(true)}
                startIcon={<AddIcon />}
                disabled={!checkRolesAuth('createProject')}
                sx={{
                  minWidth: '120px',
                  borderRadius: '0 8px 8px 0',
                  textTransform: 'none',
                  fontWeight: 500,
                  padding: theme.spacing(1, 2),
                  boxShadow: 'none',
                  marginLeft: '-1px',
                  color: '#ffffff !important',
                  '&:hover': {
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
                    color: '#ffffff !important'
                  },
                  '&.Mui-disabled': {
                    color: 'rgba(255, 255, 255, 0.7) !important'
                  }
                }}
              >
                Yeni
              </Button>
            </Grid>
          </Grid>
        </Box>
        
        <Divider />
        
        <CardContent sx={{ padding: 0 }}>
          <TableContainer className={classes.tableContainer}>
            <Table stickyHeader aria-label="hvac projects table">
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={HvacData?.length}
                theme={theme}
                selected={selected}
              />
              <TableBody>
                {HvacData?.length === 0 && !loading ? (
                  <TableRow>
                    <TableCell colSpan={headCells.length} align="center">
                      <Box className={classes.emptyState}>
                        <SearchIcon sx={{ fontSize: 64, color: '#cbd5e1', mb: 2 }} />
                        <Typography variant="h6" sx={{ color: '#64748b', mb: 1 }}>
                          Sonuç Bulunamadı
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                          Arama kriterlerinize uygun proje bulunamadı. Lütfen farklı filtreler deneyin.
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  stableSort(HvacData, getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      if (typeof row === 'number') return null;
                      const isItemSelected = isSelected(row.name);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected}
                          sx={{
                            '&:hover': {
                              backgroundColor: '#f8fafc',
                              cursor: 'pointer'
                            }
                          }}
                        >
                          <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 600, color: '#1e293b' }}>
                            {row.ProjectCode}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap', color: '#475569' }}>
                            {row.ProjectOwner}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap', maxWidth: 300, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <Tooltip title={row.Description || ''} arrow>
                              <span>{row.Description}</span>
                            </Tooltip>
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            <Box
                              sx={{
                                px: 1.5,
                                py: 0.5,
                                borderRadius: '6px',
                                backgroundColor: '#e0f2fe',
                                color: '#0369a1',
                                fontSize: '0.75rem',
                                fontWeight: 600,
                                display: 'inline-block'
                              }}
                            >
                              {row.ProjectType}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {row.ServiceShop}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {row.MentorServiceShop}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {row.Dealer}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {row.Region}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            {row.City}
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap' }}>
                            <Box
                              className={classes.completionBadge}
                              sx={{
                                backgroundColor: 
                                  parseInt(row.CompletionPercentage) >= 75 ? '#d1fae5' :
                                  parseInt(row.CompletionPercentage) >= 50 ? '#fef3c7' :
                                  parseInt(row.CompletionPercentage) >= 25 ? '#fed7aa' : '#fecaca',
                                color:
                                  parseInt(row.CompletionPercentage) >= 75 ? '#065f46' :
                                  parseInt(row.CompletionPercentage) >= 50 ? '#78350f' :
                                  parseInt(row.CompletionPercentage) >= 25 ? '#9a3412' : '#991b1b'
                              }}
                            >
                              {row.CompletionPercentage || '0%'}
                            </Box>
                          </TableCell>
                          <TableCell sx={{ whiteSpace: 'nowrap', fontSize: '0.813rem', color: '#64748b' }}>
                            {row.CreateDate}
                          </TableCell>
                          <TableCell 
                            sx={{ whiteSpace: 'nowrap' }} 
                            onClick={event => handleClick(event, row)}
                            align="center"
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 0.5,
                                '& .MuiFab-root': {
                                  transition: 'all 0.2s ease',
                                  '&:hover': {
                                    transform: 'scale(1.1)'
                                  }
                                }
                              }}
                            >
                              {/* Bilgi/Görüntüleme Grubu */}
                              <Tooltip title="Yorumlar" arrow placement="top">
                                <Fab
                                  size="small"
                                  aria-label="Yorumlar"
                                  sx={{
                                    backgroundColor: '#e0f2fe',
                                    boxShadow: 'none',
                                    width: 32,
                                    height: 32,
                                    minHeight: 32,
                                    '&:hover': {
                                      backgroundColor: '#bae6fd',
                                      boxShadow: '0 2px 8px rgba(2, 132, 199, 0.25)'
                                    },
                                    '& .MuiSvgIcon-root': {
                                      color: '#0284c7 !important'
                                    }
                                  }}
                                  onClick={() => {
                                    handleClose();
                                    handleCommentClick();
                                  }}
                                >
                                  <CommentIcon sx={{ fontSize: '1rem' }} />
                                </Fab>
                              </Tooltip>
                              
                              <Tooltip title="Son Güncellemeler" arrow placement="top">
                                <span>
                                  <Fab
                                    size="small"
                                    aria-label="Son Güncellemeler"
                                    disabled={!checkRolesAuth('Log')}
                                    sx={{
                                      backgroundColor: '#fef3c7',
                                      boxShadow: 'none',
                                      width: 32,
                                      height: 32,
                                      minHeight: 32,
                                      '&:hover': {
                                        backgroundColor: '#fde68a',
                                        boxShadow: '0 2px 8px rgba(217, 119, 6, 0.25)'
                                      },
                                      '&.Mui-disabled': {
                                        backgroundColor: '#f5f5f5',
                                        '& .MuiSvgIcon-root': {
                                          color: '#bdbdbd !important'
                                        }
                                      },
                                      '& .MuiSvgIcon-root': {
                                        color: '#f59e0b !important'
                                      }
                                    }}
                                    onClick={() => {
                                      handleClose();
                                      handleLogsClick();
                                    }}
                                  >
                                    <NotificationsActiveIcon sx={{ fontSize: '1rem' }} />
                                  </Fab>
                                </span>
                              </Tooltip>

                              {/* Ayırıcı */}
                              <Box sx={{ width: '1px', height: 20, backgroundColor: '#e2e8f0', mx: 0.5 }} />

                              {/* Düzenleme Grubu */}
                              <Tooltip title="Projeyi Düzenle" arrow placement="top">
                                <Fab
                                  size="small"
                                  aria-label="Güncelle"
                                  sx={{
                                    backgroundColor: '#dbeafe',
                                    boxShadow: 'none',
                                    width: 32,
                                    height: 32,
                                    minHeight: 32,
                                    '&:hover': {
                                      backgroundColor: '#bfdbfe',
                                      boxShadow: '0 2px 8px rgba(37, 99, 235, 0.25)'
                                    },
                                    '& .MuiSvgIcon-root': {
                                      color: '#3b82f6 !important'
                                    }
                                  }}
                                  onClick={() => {
                                    handleClose();
                                    handleEditClick();
                                  }}
                                >
                                  <EditIcon sx={{ fontSize: '1rem' }} />
                                </Fab>
                              </Tooltip>
                              
                              <Tooltip title="Fiş İşlemleri" arrow placement="top">
                                <Fab
                                  size="small"
                                  aria-label="Fiş İşlemleri"
                                  sx={{
                                    backgroundColor: '#d1fae5',
                                    boxShadow: 'none',
                                    width: 32,
                                    height: 32,
                                    minHeight: 32,
                                    '&:hover': {
                                      backgroundColor: '#a7f3d0',
                                      boxShadow: '0 2px 8px rgba(5, 150, 105, 0.25)'
                                    },
                                    '& .MuiSvgIcon-root': {
                                      color: '#22c55e !important'
                                    }
                                  }}
                                  onClick={() => {
                                    handleClose();
                                    handleReceiptClick(true);
                                  }}
                                >
                                  <ReceiptIcon sx={{ fontSize: '1rem' }} />
                                </Fab>
                              </Tooltip>

                              {/* Ayırıcı */}
                              <Box sx={{ width: '1px', height: 20, backgroundColor: '#e2e8f0', mx: 0.5 }} />

                              {/* Tehlikeli İşlem */}
                              <Tooltip title="Projeyi Sil" arrow placement="top">
                                <Fab
                                  size="small"
                                  aria-label="Sil"
                                  sx={{
                                    backgroundColor: '#fee2e2',
                                    boxShadow: 'none',
                                    width: 32,
                                    height: 32,
                                    minHeight: 32,
                                    '&:hover': {
                                      backgroundColor: '#fecaca',
                                      boxShadow: '0 2px 8px rgba(220, 38, 38, 0.25)'
                                    },
                                    '& .MuiSvgIcon-root': {
                                      color: '#ef4444 !important'
                                    }
                                  }}
                                  onClick={() => {
                                    handleClose();
                                    handleDeleteClick();
                                  }}
                                >
                                  <DeleteIcon sx={{ fontSize: '1rem' }} />
                                </Fab>
                              </Tooltip>
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
        
        <Divider />
        
        <CardActions sx={{ padding: theme.spacing(2), justifyContent: 'flex-end', backgroundColor: '#fafafa' }}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            component="div"
            count={HvacData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Sayfa başına satır:"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
          />
        </CardActions>
      </Card>
      <CreateProjectDialog
        open={OpenCreateDialog}
        setOpen={setOpenCreateDialog}
        HavcAddressData={HavcAddressData}
        sorgula={sorgula}
      />
      <HavcLogs
        open={OpenLogsDialog}
        setOpen={setOpenLogsDialog}
        projectId={selectedRow.ProjectID}
        HavcAddressData={HavcAddressData}
      />
      <CommentPopup
        open={openCommentDialog}
        setOpen={setOpenCommentDialog}
        projectId={selectedRow.ProjectID}
      />
      <UpdateProjectDialog
        open={OpenUpdateDialog}
        setOpen={setOpenUpdateDialog}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        HavcAddressData={HavcAddressData}
        sorgula={sorgula}
        onUpdateSuccess={handleUpdateSuccess}
      />
      {console.log(OpenReceiptsDialog)}
      <Receipts
        open={OpenReceiptsDialog}
        setOpen={setOpenReceiptsDialog}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        sorgula={sorgula}
        fislerYeniEkraniAc={fislerYeniEkranAc}
        onUpdateSuccess={handleUpdateSuccess}
      />
      <DeleteProjectDialog
        open={OpenDeleteProjectDialog}
        setOpen={setOpenDeleteProjectDialog}
        ProjectID={selectedRow.ProjectID}
        sorgula={sorgula}
      />
    </Page>
  );
}

export default HVAC;
